import React, {Component} from 'react'
import {connect} from 'react-redux'
import Home from '../components/Home'
import {handleTypeheadSearch} from "../components/form/form";
import {findParties} from "../actions/parties";
import {createPartyOption} from "../utils";
import {PartyRole} from "../utils/enums";

class HomePage extends Component {

	findPartiesTimeout: null;

	constructor(props) {
		super(props);

		this.handleFindParties = this.handleFindParties.bind(this);
		this.handleFindPartiesubmit = this.handleFindPartiesubmit.bind(this);
	}

	componentWillUnmount() {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}
	}

	handleFindParties(search, callback) {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}

		this.findPartiesTimeout = setTimeout(() => {
			handleTypeheadSearch({search, roles: [PartyRole.WALKER]}, createPartyOption, this.props.findParties, callback);
		}, search ? 500 : 0);
	}

	handleFindPartiesubmit(partyId) {
		this.props.history.push('/vychazky/nova/' + partyId)
	}

	render() {
		return (
			<div>
				<Home onFindParties={this.handleFindParties} onSubmitParty={this.handleFindPartiesubmit}/>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {}
};

export default connect(mapStateToProps, {findParties})(HomePage)



// WEBPACK FOOTER //
// ./src/containers/HomePage.js